import React from 'react';
import Footer from '../Footer/Footer';
import './Careers.css';

const Careers = () => {
  const offerings = [
    {
      title: "Full Time Equivalent (FTE)",
      description:
        "Our FTE model provides dedicated resources for your projects, ensuring consistent support and expertise throughout the research process.",
    },
    {
      title: "Fee For Service (FFS)",
      description:
        "The FFS model offers a cost-effective solution for specific, well-defined tasks, with clear deliverables and timelines.",
    },
    {
      title: "Milestone Based",
      description:
        "Our Milestone Based approach ensures progress-driven engagement, with payments tied to predefined project milestones.",
    },
  ];

  const services = [
    {
      title: "Process Chemistry",
      description:
        "We optimize chemical processes for scalability and efficiency, supporting pharmaceutical and industrial applications.",
    },
    {
      title: "Discovery Chemistry",
      description:
        "Our team accelerates drug discovery through innovative synthesis and screening of novel compounds.",
    },
    {
      title: "Organic Synthesis",
      description:
        "We specialize in the synthesis of complex organic molecules, delivering high-purity intermediates and APIs.",
    },
    {
      title: "Chiral Synthesis",
      description:
        "Our expertise in chiral synthesis ensures the production of enantiomerically pure compounds for advanced research.",
    },
  ];

  return (
    <>
      <div>
        <div className="varanous-page-container">
          {/* Hero Section */}
          <section className="varanous-life-section">
            <div className="varanous-hero-banner">
              <div className="varanous-hero-text">
                <h1 className="varanous-title">Varanous Labs</h1>
              </div>
            </div>
          </section>

          {/* Business Offerings Section */}
          <section className="benefits-section">
            <div className="benefits-header">
              <h2 className="benefit-title">Our Business Offerings</h2>
              <p className="benefit-intro">
                At Varanous Labs, we provide flexible engagement models to meet the diverse needs of our global clients in Pharmaceutical, Agrochemicals, Biotech, and Academic Research sectors.
              </p>
            </div>
            <div className="benefit-cards">
              {offerings.map((offering, idx) => (
                <div key={idx} className="benefit-card">
                  <h4>{offering.title}</h4>
                  <p>{offering.description}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Services Section */}
          {/* <section className="benefits-section">
            <div className "benefits-header">
              <h2 className="benefit-title">Our Services</h2>
              <p className="benefit-intro">
                We offer a wide range of chemistry-driven services to support your research and development needs, ensuring high-quality outcomes and innovative solutions.
              </p>
            </div>
            <div className="benefit-cards">
              {services.map((service, idx) => (
                <div key={idx} className="benefit-card">
                  <h4>{service.title}</h4>
                  <p>{service.description}</p>
                </div>
              ))}
            </div>
          </section> */}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Careers;